import {
    BackButton,
    convertFromBoolean,
    convertToBoolean,
    Divider,
    Form,
    FormDate,
    FormDropDown,
    FormInput,
    FormRadio,
    Header,
    setAttributeEntity,
    useAlignments,
    useSizes,
} from 'metrix-common3';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileDriverClaim = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    return (
        <React.Fragment>
            <BackButton clickEvent={props.backEvent} />
            <Divider top={sizes.md} />
            <Header
                size={sizes.md}
                textAlign={alignments.left}
                text={<FormattedMessage id='Profile_Drivers_Claim.claim' />}
            />
            <Form
                label={<FormattedMessage id='Profile_Drivers_Claim.claimDetails' />}
                allowEdit={props.allowEdit}
                saveEvent={() => props.doUpsertPolicy()}
                cancelEvent={() => props.doGetPolicy()}
            >
                <FormDate
                    label={<FormattedMessage id='Profile_Drivers_Claim.dateOfClaim' />}
                    value={props.claim?.claimDate}
                    changeEvent={(value) => props.doReducePolicyElement({ code: `${props.dotProp}claimDate`, value })}
                    culture={props.context.session.culture}
                    mode='past'
                    allowEdit
                />
                <FormDropDown
                    label={<FormattedMessage id='Profile_Drivers_Claim.claimReason' />}
                    value={props.claim?.reason}
                    references={props.reference.references?.AutoClaim}
                    referencesEvent={() => props.reference.doGetReferences('AutoClaim')}
                    changeEvent={(value) =>
                        setAttributeEntity(`${props.dotProp}reason`, value, props.doReducePolicyElement)
                    }
                    allowEdit
                />
                <FormInput
                    label={<FormattedMessage id='Profile_Drivers_Claim.lossAmount' />}
                    value={props.claim?.lossAmount?.value}
                    changeEvent={(value) => {
                        props.doReducePolicyElement({ code: `${props.dotProp}lossAmount.value`, value });
                        props.doReducePolicyElement({ code: `${props.dotProp}lossAmount.currency`, value: 'cad' });
                    }}
                    allowEdit
                />
                <FormRadio
                    label={<FormattedMessage id='Profile_Drivers_Claim.atFault' />}
                    value={props.claim && { code: convertFromBoolean(props.claim.atFault) }}
                    references={props.reference.references?.YesNo}
                    referencesEvent={() => props.reference.doGetReferences('YesNo')}
                    changeEvent={(value) =>
                        props.doReducePolicyElement({
                            code: `${props.dotProp}atFault`,
                            value: convertToBoolean(value.code),
                        })
                    }
                    allowEdit
                />
            </Form>
        </React.Fragment>
    );
};

export default ProfileDriverClaim;
